import { memo, useCallback, useEffect, useMemo, useState } from "react"
import { currencies } from "constants/currency-select"
import styled from "styled-components"
import SelectV2, { Option } from "./EvtKit/select/SelectV2"

const Container = styled.div`
  width: 100%;
`

interface InputDataState {
  inputKey: string
  inputName: string
  inputPrice: string
  checkSimplePricing: boolean
  selectAccounts: string
  selectPurchasePlan: string
  selectCurrencyType: string
  inputFreeTrialDuration: {
    usageLimit: number
  }
}

interface CurrencySelectProps {
  value: string
  label: string
  setInputData: React.Dispatch<React.SetStateAction<InputDataState>>
}

const CurrencySelect = (props: CurrencySelectProps) => {
  const { value, label, setInputData } = props

  const memoizedCurrencies = useMemo(() => currencies, [currencies])

  const [selectedCurrency, setSelectedCurrency] = useState<string>("")

  useEffect(() => {
    setSelectedCurrency(value)
  }, [value])

  const handleCurrencyChange = useCallback(
    (currency: Option | null) => {
      setSelectedCurrency(currency?.value || "")
      setInputData((prevState) => ({
        ...prevState,
        selectCurrencyType: currency?.value || ""
      }))
    },
    [setInputData]
  )

  return (
    <Container>
      <SelectV2
        id="currencyType"
        options={memoizedCurrencies}
        value={selectedCurrency}
        onChange={handleCurrencyChange}
        label={label}
      />
    </Container>
  )
}

export default memo(CurrencySelect)
